import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import * as ActionsLogin from '../../redux/modules/login';
import { auth } from '../../services/auth';

class Logout extends PureComponent {

  componentDidMount() {
    this.props.logout();
    auth.clearAllAppStorage();
  }

  render() {
    return (<Redirect to="/login"/>);
  }
}

export default connect(
  (state) => {
    return {
      login: state.login
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        logout: ActionsLogin.logout
      }, dispatch);
  }
)(Logout);



// WEBPACK FOOTER //
// ./src/containers/logout/Logout.js